export const WEB_API_GET_DOCUMENTS = (version) => `/v${version}/Document/Get`;

export const WEB_API_GET_DOCUMENT_BY_ID = (version, id) => `/v${version}/Document/Get/${id}`;

export const WEB_API_GET_DOCUMENTS_BY_TITLE = (version, title) =>
  `/v${version}/Document/GetByTitle?title=${encodeURIComponent(title || '')}`;

export const WEB_API_GET_SECTIONS_BY_TITLE = (version, documentId, title) =>
  `/v${version}/Section/GetByTitle?documentId=${encodeURIComponent(documentId || '')}&title=${encodeURIComponent(title || '')}`;

export const WEB_API_GET_GLOSSARY_BY_TITLE = (version, title) =>
  `/v${version}/Document/GetGlossaryByTitle?title=${encodeURIComponent(title || '')}`;

export const WEB_API_SEARCH = (version, q) =>
  `/v${version}/Search/Get?q=${encodeURIComponent(q || '')}`;

export const WEB_API_GET_SECTIONS_BY_ID = (version, id) => `/v${version}/Document/GetSections/${id}`;

export const WEB_API_GET_RELATED_DOCS_BY_ID = (version, id) => `/v${version}/Document/GetRelatedDocuments/${id}`;

export const WEB_API_GET_DOC_GLOSSARY_BY_ID = (version, id) => `/v${version}/Document/GetGlossary/${id}`;

export const WEB_API_GET_SECTION_BY_PAGE_ID = (version, id) => `/v${version}/Section/Get/${id}`;

export const WEB_API_GET_RELATED_SECTION_BY_ID = (version, id) => `/v${version}/Section/GetRelatedSections/${id}`;

export const WEB_API_GET_SUMMARY_BY_DOC_ID = (version, id) => `/v${version}/Document/GetSummary/${id}`;

// AI query — POST { query, documentIds } to get an AI-generated answer about the document(s).
export const WEB_API_QUERY_DOCUMENTS = (version) => `/v${version}/Document/Query`;

// The caller's own recent AI queries (history). Unmetered, client-scoped.
export const WEB_API_GET_MY_QUERIES = (version, take) =>
  `/v${version}/ApiQuery/my?take=${encodeURIComponent(take || 20)}`;

// AI document comparison — POST two document versions to compare.
export const WEB_API_COMPARE = (version) => `/v${version}/Comparison/Compare`;

// Related content (supplementary resources): resolved for a document, or for a taxonomy item.
export const WEB_API_GET_RELATED_CONTENT_BY_DOC = (version, documentId) =>
  `/v${version}/RelatedContent/GetByDocument/${documentId}`;
export const WEB_API_GET_RELATED_CONTENT_BY_TAXONOMY_ITEM = (version, taxonomy, itemId) =>
  `/v${version}/RelatedContent/GetByTaxonomyItem?taxonomy=${encodeURIComponent(taxonomy || '')}&itemId=${encodeURIComponent(itemId || '')}`;

// --- Taxonomies --- the classification scheme. Discovery lists the taxonomies; then items by
// taxonomy key, a single item by id, and the documents tagged with an item. Keys come from the
// discovery call (e.g. "regulator").
export const WEB_API_GET_TAXONOMIES = (version) => `/v${version}/Taxonomies`;

export const WEB_API_GET_TAXONOMY_ITEMS = (version, taxonomy) =>
  `/v${version}/Taxonomies/${encodeURIComponent(taxonomy || '')}/items`;

export const WEB_API_GET_TAXONOMY_ITEM = (version, taxonomy, id) =>
  `/v${version}/Taxonomies/${encodeURIComponent(taxonomy || '')}/items/${encodeURIComponent(id || '')}`;

export const WEB_API_GET_TAXONOMY_ITEM_DOCUMENTS = (version, taxonomy, id) =>
  `/v${version}/Taxonomies/${encodeURIComponent(taxonomy || '')}/items/${encodeURIComponent(id || '')}/documents`;
